// extracted by mini-css-extract-plugin
export var chip = "_cm-0";
export var filterDropdown = "_cm-5";
export var filterItem = "_cm-6";
export var icon = "_cm-1";
export var removeButton = "_cm-3";
export var removeIcon = "_cm-4";
export var separator = "_cm-2";